export const LETTER_BOX_SIDE_LENGTH = 64;
export const ROW_GAP = 4;
